import { useState, useEffect, useCallback } from "react";
import { Container, Graphics, Text } from "@pixi/react";
import { Assets } from "pixi.js";
import { useAppDispatch } from "../../app/hooks";
import { appSlice } from "../../app/appSlice";

function Loader(props) {
  const width = 2000;
  const height = 1125;
  const [scale, setScale] = useState(
    window.innerWidth / window.innerHeight < width / height
      ? window.innerWidth / width
      : window.innerHeight / height
  );

  useEffect(() => {
    const handleWindowResize = () => {
      setScale(
        window.innerWidth / window.innerHeight < width / height
          ? window.innerWidth / width
          : window.innerHeight / height
      );
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [setScale]);

  const dispatch = useAppDispatch();

  const [loadingProgress, setLoadingProgress] = useState(0);

  Assets.add("sprites", "pool-animation/sprite-sheets/pool-assets-0.json");
  useEffect(() => {
    Assets.load(["sprites"], (p) => {
      setLoadingProgress(p);
    }).then(() => {
      dispatch(appSlice.actions.setLoadingAssets(false));
    });
  }, [dispatch]);

  const loaderBarWidth = width * 0.3; // just an auxiliar variable
  const drawFill = useCallback(
    (g) => {
      g.clear();
      g.beginFill(0x0000bb, 1);
      g.drawRect(0, 0, loaderBarWidth, 15);
      g.endFill();
    },
    [loaderBarWidth]
  );

  const drawBorder = useCallback(
    (g) => {
      g.clear();
      g.lineStyle(3, 0x0, 1);
      g.drawRect(0, 0, loaderBarWidth, 15);
    },
    [loaderBarWidth]
  );

  return (
    <Container
      x={(width - loaderBarWidth) * 0.5 * scale}
      y={height * scale * 0.5}
      scale={{ x: scale, y: scale }}
      anchor={{ x: 0.5, y: 0.5 }}
    >
      <Graphics
        draw={drawFill}
        scale={{ x: loadingProgress, y: 1 }}
        anchor={{ x: 0.5, y: 0.5 }}
      />
      <Graphics draw={drawBorder} anchor={{ x: 0.5, y: 0.5 }} />
    </Container>
  );
}

export default Loader;
